import axios from 'axios';
import { message } from 'antd';
import { URL_ENDPOINT } from '../../../index';
import { ADD_SUPPLIER_FROM_SOCKET, GET_SUPPLIERS, ADD_GHOST_SUPPLIER, RESET_GHOST_SUPPLIER, RESET_SUPPLIER_ERROR } from './types';

export const addSupplierFromSocket = (supplier) => {
	return {
		type: ADD_SUPPLIER_FROM_SOCKET,
		supplier
	}
}

export const addGhostSupplier = (supplierDetails) => {
	return {
		type: ADD_GHOST_SUPPLIER,
		payload: axios({
			method:'post',
			url:`${URL_ENDPOINT}/api/admin/supplier/ghost`,
			withCredentials:true,
			data: supplierDetails
		})
	}
}

export const getSuppliers = () => {
	return {
		type: GET_SUPPLIERS,
		payload: axios({
			method:'get',
			withCredentials: true,
			url:`${URL_ENDPOINT}/api/admin/supplier/all`
		})
	}
}

export const resetGhostSupplier = () => {
	return {
		type: RESET_GHOST_SUPPLIER
	}
}

export const resetSupplierError = () => {
	return {
		type: RESET_SUPPLIER_ERROR
	}
}


export const sendPo = ({cartId, refNumber, supplierId, supplierName}) => {
	
	const loadingMessage = message.loading(`sending purchase order ${refNumber} to ${supplierName}`, 0);

	axios({
		withCredentials: true,
		url: `${URL_ENDPOINT}/api/admin/supplier/po/${supplierId}/${cartId}`,
		method: 'post'
	})
		.then( res => {

				loadingMessage();
				message.success(`Sent purchase order ${refNumber} to ${supplierName}`);

		})
		.catch( (err) => {
			console.log(err);
			if(err.message){
				message.error(err.message);
			}
		})

	return {
		type: "SEND_PO"
	}

}


// WEBPACK FOOTER //
// ./src/components/supplier/actions/index.js